<template>
	<o-tour :ref="setup._tourOrder">
		<o-tour-step
			:title="$t('business.tour.step1.title')"
			hide-finish>
			<p>
				{{ $t('business.tour.step1.regularUser') }}
			</p>
			<div>
				{{ $t('business.tour.step1.novice') }}
			</div>
		</o-tour-step>

		<o-tour-step
			v-if="!setup.ui.onLayoutNavBottom"
			:title="$t('business.tour.step2.title')"
			hide-finish
			:target="setup.orderListOrderBy.bind(setup)">
			<div>
				<p>
					{{ $t('business.settings.agency.contract.listsCanBeSorted') }}
				</p>
				<p>
					{{ $t('business.settings.agency.contract.sortByMissionStartDate') }}
				</p>
				{{ $t('business.settings.agency.contract.displayOrderNotSuitable') }}
			</div>
		</o-tour-step>

		<o-tour-step
			v-if="setup.canWrite"
			:title="$t('business.tour.step3.title')"
			hide-finish
			target="order-add-button">
			<div>
				<p>
					{{ $t('business.settings.agency.contract.dependingOnRights') }}
				</p>
				{{ $t('business.creation.createNewOrder') }}
				<span v-if="setup.self.isAgency()">
					{{ $t('business.settings.agency.contract.forOneOfYourCompanies') }}
				</span>
				<span v-else>
					{{ $t('business.settings.agency.contract.forYourEmploymentAgency') }}
				</span>
			</div>
		</o-tour-step>

		<o-tour-step
			v-if="setup.hasData"
			:title="$t('business.tour.step4.title')"
			size="lg"
			target="order-el-0">
			<div>
				<p v-html="$t('common.order.listElements')"/>
				<p v-html="$t('common.order.stickerContent')"/>
				{{ $t('common.order.hereForExample') }}
				<ul>
					<li v-html="$t('business.company.companies')"/>
					<li v-html="$t('common.order.qualification')"/>
					<li v-html="$t('common.order.dates')"/>
					<li v-html="$t('business.order.location')"/>
					<li
						v-if="setup.self.isAgency()"
						v-html="$t('common.order.agencyStatus')"/>
					<li
						v-else
						v-html="$t('common.order.clientStatus')"/>
					<li v-html="$t('common.order.hoverActions')"/>
				</ul>

				<p v-html="$t('common.order.notComplicated')"/>

				<i v-html="$t('common.order.stickerNote')"/>
			</div>
		</o-tour-step>

		<o-tour-step
			v-else
			:title="$t('business.tour.step5.title')">
			<p v-html="$t('common.order.emptyList')"/>
			<span v-html="$t('common.order.yourTurn')"/>
			<span
				v-if="setup.self.isAgency()"
				v-html="$t('common.order.agencyWait')"/>
			<span
				v-else
				v-html="$t('common.order.clientCreate')"/>
		</o-tour-step>
	</o-tour>
</template>

<script setup lang="ts">
// #region Setup
import type { TourOrderEmits, TourOrderProps } from './TourOrderSetup';
import TourOrderSetup from './TourOrderSetup';
const emits = defineEmits<TourOrderEmits>() as TourOrderEmits;
const props = withDefaults(defineProps<TourOrderProps>(), TourOrderSetup.defaultProps);
const setup = new TourOrderSetup(props, emits);
// #endregion
</script>
